export default function showLoader($el: JQuery<HTMLElement>) {
    $el.hide();
    if ($el.next('.spinner-border').length) {
        return;
    }
    $el.after($('<div class="spinner-border" role="status"></div>'));
}
